import { render, staticRenderFns } from "./Charts.vue?vue&type=template&id=8b23c228&scoped=true&"
import script from "./Charts.vue?vue&type=script&lang=ts&"
export * from "./Charts.vue?vue&type=script&lang=ts&"
import style0 from "./Charts.vue?vue&type=style&index=0&id=8b23c228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b23c228",
  null
  
)

export default component.exports